// @flow

import React, { type Node } from 'react';

import { isolateComponent } from '@zapier/common-utils';

import ContentFooter from 'web-ssr/app/common/components/ContentFooter';
import ContentHeader from 'web-ssr/app/common/components/ContentHeader';

/** @jsx isolateComponent */

type Props = {
  /**
   * Content to render within the page.
   */
  children: Node,
  /**
   * Content to render within the header area of the page.
   */
  renderHeader: () => Node,
  /**
   * Content to render within the footer area of the page.
   */
  renderFooter: () => Node,
};

const GlobalLayout = (props: Props) => {
  return (
    <React.Fragment>
      {props.renderHeader()}
      {props.children}
      {props.renderFooter()}
    </React.Fragment>
  );
};

GlobalLayout.defaultProps = {
  renderHeader: () => <ContentHeader />,
  renderFooter: () => <ContentFooter />,
};

export default GlobalLayout;
